import { useEffect, useState } from 'react';
import { subscribeToMessages } from '../services/messageService';

const useChat = (currentUserId, otherUserId) => {
    const [messages, setMessages] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        if (!currentUserId || !otherUserId) {
            setMessages([]);
            setLoading(false);
            return;
        }

        setLoading(true);
        const unsubscribe = subscribeToMessages(
            currentUserId,
            otherUserId,
            (docs) => {
                setMessages(docs);
                setLoading(false);
                setError(null);
            },
            (err) => {
                console.error('useChat subscription error', err);
                setError(err);
                setLoading(false);
            }
        );

        return () => unsubscribe();
    }, [currentUserId, otherUserId]);

    return { messages, loading, error };
};

export default useChat;

